import { Heading } from "@chakra-ui/react";
import { PermissionModalMode } from "types/PermissionModalMode";

type RoleModalTitleProps = {
  modalMode: PermissionModalMode;
  roleTitle: string;
};

/**
 * Component that renders the title for the Role Modal based on the current modal mode.
 *
 * @param {RoleModalTitleProps} props - The props for the component.
 * @param {PermissionModalMode} props.modalMode - The current mode of the modal (Create, View, Edit, Delete).
 * @param {string} props.roleTitle - The title of the role being viewed, edited, or deleted.
 *
 * @returns {JSX.Element} The rendered title for the Role Modal.
 */
export default function RoleModalTitle({ modalMode, roleTitle }: RoleModalTitleProps) {
  return (
    <>

      {
        modalMode === PermissionModalMode.Create &&
        <Heading as="h2" size="lg">
          Aggiungi un nuovo ruolo
        </Heading>
      }

      {
        modalMode === PermissionModalMode.View &&
        <Heading as="h2" size="lg">
          Visualizzazione Ruolo {roleTitle}
        </Heading>
      }

      {
        modalMode === PermissionModalMode.Edit &&
        <Heading as="h2" size="lg" >
          Modifica Permessi Ruolo {roleTitle}
        </Heading>
      }

      {
        modalMode === PermissionModalMode.Delete &&
        <Heading as="h2" size="lg" >
          Elimina il Ruolo {roleTitle}
        </Heading>
      }

    </>
  );
}
